(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7971],{

/***/ 7099:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancellation-and-refundpolicies",
      function () {
        return __webpack_require__(3551);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 3551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CancellationandRefund; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(256);
/* harmony import */ var _styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6240);




function CancellationandRefund() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Cancellation And Refund Policy | The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Read how our policy offers flexibility for your changing plans. kindly ensure reservation cancellation at least 7 days prior to the scheduled arrival date."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com/cancellation-and-refundpolicy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bgImage: "/images/refund-banner.png",
                title: "Cancellation And Refund Policy"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3___default().privacy_policy), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "common_title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Check-In After: 14:00hrs Check-Out Time before : 11:00hrs"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "ROOM CANCELLATION/NO-SHOW ."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Booking must be guaranteed after the advance payment . All Major credit cards accepted except Amex card. Reservation must be\xa0cancelled\xa07 days prior to the planned date of arrival. 50% room charge will be levied in case of reservation\xa0cancelled\xa0within 7 days prior to the date of check in."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "All the early departures/ No show will be charged 100% retention as per the original reservation and to be settled by the booker /guest before departure."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "The Booker / Guest will be responsible for the late cancellation, no show charges and early departure charges."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "The Booker/ Guest is allowed to modify/cancel the reservation by email."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Group Cancellation:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Group Cancellation In an event of cancellation after confirmation, please refer to the following. Any deposits paid are included in the overall cancellation penalty:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "All cancellations /modify must be notified in writing."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                className: "my_table",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: "Period Prior to Expected Arrival"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: "Cancellation Fee"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "90 days before check in date"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "Between 60 and 30 days prior to arrival"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "25%"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "50%"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "Between 30 and 0 days prior to arrival"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "100%"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Force Clause Majeure:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "The performance of this agreement is subject to termination without liability upon the occurrence of any circumstances beyond the control of either party such as strikes, civil disorder, natural calamities, government regulations or curtailment of transportation facilities (except those involving the employees or agents of the parties seeking protection of this clause) – to the extent that such circumstance make it legal or impossible to provide or use the hotel facilities. The ability to terminate this agreement without liability pursuant to this paragraph is conditional upon delivery of practical: but in no event later than 10 days after learning of such basis. The client agrees that if the event is canceled due to Force Majeure they will rebook in future (within 3 months) as per availability on the hotel. The rates applicable for the re booking option will be as per the hotel strategy for that period."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Jurisdiction:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "This contract shall be constructed and interpreted in accordance with the laws of India. The Shimla courts have exclusive jurisdiction to try all the disputes arising out of this booking."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "PR/Media Policy:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "The booker shall not use the same name, logo, trademark or other proprietary designation of The Twin Towers Hotel. The booker/ Guest agree not to publish any advertising or promotional materials without the prior written approval of the hotel."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "Note :"
                                    }),
                                    " As per the Government directives it is Mandatory for all the guest (Foreign Nationals , NRI’s and Indian Nationals) to show their Photo ID proof at the time of Check-In which can be in form of ‘Passport and Visa Copy, Driving License, Voter ID Card , failing which the hotel reserves the right of refusal. No provision for maid ,\xa0driver accommodation and pets. To ensure a safe travel experience, you all\xa0are advised to carry a negative report of RT-PCR test report or reach before 4 PM in the hotel specially in Winter season."
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home_banner":"Home_home_banner__kArgw","banner_text":"Home_banner_text__nh89y","banner_text_con":"Home_banner_text_con__Jogsr","videobanner":"Home_videobanner__Tkj0g","video_bg":"Home_video_bg__qf_ah","hyperlink_button":"Home_hyperlink_button__y667M","single_hotel_search_form_container":"Home_single_hotel_search_form_container__HqA9G","home_banner_image":"Home_home_banner_image__t3akK","mobiel_home_banner_image":"Home_mobiel_home_banner_image__GUcAt","banner_video":"Home_banner_video__SddjS","banner_slider_wrapper":"Home_banner_slider_wrapper__UTLDE","slick_slide":"Home_slick_slide__qJU2c","slick_slide_image":"Home_slick_slide_image__hhGEg","slick_slide_text":"Home_slick_slide_text__O67as","slick-prev":"Home_slick-prev__4656Z","slick-next":"Home_slick-next__1kKST","booking_sec":"Home_booking_sec__HpePc","booking_cont":"Home_booking_cont__fMu_2","booking_col":"Home_booking_col__dOC3d","button_col":"Home_button_col__bFrbD","check_now_btn":"Home_check_now_btn__mHeYn","room_con":"Home_room_con__yiOP5","room_left":"Home_room_left__idckC","room_center":"Home_room_center__k4vSt","room_right":"Home_room_right__erFsr","room_right_bottom":"Home_room_right_bottom__kmBTr","right_bottom_text":"Home_right_bottom_text__mvi4g","button_sec":"Home_button_sec__MdG6_","hall_sec":"Home_hall_sec__fTUX9","image_sec":"Home_image_sec__tFNpX","image_sec_left":"Home_image_sec_left__werHr","conference_btn":"Home_conference_btn__XZpN3","image_overlay":"Home_image_overlay__Cp9qu","activities_sec":"Home_activities_sec__ARKi1","activities_slider":"Home_activities_slider___q9lq","activity_child":"Home_activity_child__uN8Qi","activity_bg_image":"Home_activity_bg_image__ugYWi","activity_overlay":"Home_activity_overlay__t5zMy","explore_btn":"Home_explore_btn__6MzO_","help_sec":"Home_help_sec__7Rilk","help_sec_child":"Home_help_sec_child__SIt9r","testimonial_sec":"Home_testimonial_sec__B_HiR","background_image":"Home_background_image__Vo5NE","testimonial":"Home_testimonial__QHdb5","testi_left":"Home_testi_left__0C7fk","testi_right":"Home_testi_right__QAzWv","blogs_sec":"Home_blogs_sec__IzPka","blogs":"Home_blogs__oH2o4","single_blog_parent":"Home_single_blog_parent__Zq2Tg","all_blog_image":"Home_all_blog_image___i_Z2","all_blog_content":"Home_all_blog_content__ZBhKT","privacy_policy":"Home_privacy_policy__Z3_uX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7099); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);